import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import { ArrowRight, ChevronRight } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../contexts/LanguageContext'

const CampaignsServices = () => {
  const { t } = useLanguage();
  return (
    <div id='website-responsive' style={{ position:''}}>
        <div className='left-padding10rem1 right-padding10rem1 py-md-5 py-4'>
            <Row className=''>
                <Col sm='12' md='12' lg='6' className=''>
                    <div className='me-md-5'>
                        <div className='me-md-5'>
                            <h3 className='text-philos fs-ss-38 text-ss-black fw-800'>
                                {t('home.campaignsServices.title')}
                            </h3>
                        </div>
                        <div className='pt-md-4 pt-3 me-md-5'>
                            <p className='fs-ss-18 text-mulish fw-500 '>
                                {t('home.campaignsServices.description').split('brand growth').map((part, index, array) => {
                                    if (index === array.length - 1) return part;
                                    return (
                                        <React.Fragment key={index}>
                                            {part}
                                            <Link to='/services/branding' className='text-ss-primary' style={{ textDecoration:'none'}}>
                                                {t('common.brandGrowth')}
                                            </Link>
                                        </React.Fragment>
                                    );
                                })}
                            </p>
                        </div>
                        <div className='my-4 my-lg-5'>
                            <Link to="/about-us" className='text-decoration-none fs-ss-17 px-4 text-mulish fw-500 fw-bold text-primary-hover' style={{ border:"2px solid #FE9B1F", padding:"14px"}}>
                                <span className=' '>
                                    {t('common.learnMore')}
                                </span>
                                <ChevronRight className='ms-2 fs-ss-20'/>
                            </Link>
                        </div>
                    </div>
                </Col>
                
                <Col sm='12' md='12' lg='6' className=''>
                    <div className='pt-3'>
                        <img src='home/What-we-do.webp' alt='software development & digital marketing agency Germany' className='img-home-1' height='' width='' />
                    </div>
                </Col>
            </Row>

            <div className='mt-md-5 mt-4 mb-2'>
                <div className=''>
                    <h1 className='fs-ss-38 text-ss-black fw-800 text-philos text-center text-md-start'>
                        {t('home.campaignsServices.servicesTitle')}
                    </h1>
                </div>

                <Row className=''>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center '>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/Branding-1.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/branding' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.branding')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/Graphic-Designing-1.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/graphic-designing' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.graphicDesigning')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/Web-development.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/web-development' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.webDevelopment')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/SEO-1.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/search-engine-optimization' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.seo')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/Healthcare-Icon.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/app-development' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.appDevelopment')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/Social-Media.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/social-media-marketing' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.socialMediaMarketing')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/animation-1.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/video-animation' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.videoAnimation')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='6' lg='3' className='my-md-4 my-4 d-flex justify-content-center'>
                        <div className=''>
                            <center>
                                <div className=''>
                                    <img src='home/Paid-Marketing.webp' alt='' className='' width='' />
                                </div>
                                <div className=''>
                                    <h3 className=''>
                                        <Link to='/services/ppc-marketing' className='text-mulish fs-ss-18 text-ss-black fw-bold' style={{ textDecoration:'none'}}>
                                            {t('services.ppcMarketing')}
                                        </Link>
                                    </h3>
                                </div>
                            </center>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default CampaignsServices